import { GetVehicleModelQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleModel/getVehicleModelQuery.type';
import { getVehicleModelFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleModel/getVehicleModelQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getVehicleModelQueryOptions = (
  params: GetVehicleModelQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['vehicleModel', params],
    queryFn: () => getVehicleModelFunction(params),
  });
};
